module.exports = __webpack_public_path__ + "assets/icon-bold.1c7d2393.svg";